import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import {getLinkPath, scrollToTop} from 'app/utils';
import {NavLink} from 'react-router-dom';
import ArticlesContainer from './ArticlesContainer';

interface ArticlesByCategoryProps {
    category?: string
    articles?: ArticleInterface[]
    spriteIcon?: string
    type?: string
    slug?: string
    containerForMainPage?: boolean
}

@inject('articlesStore')
@observer
export default class ArticlesByCategory extends Component<ArticlesByCategoryProps> {
    state = {loading: false};

    render(): React.ReactNode {
        const {loading} = this.state;
        const {category, articles, spriteIcon, type, slug, containerForMainPage} = this.props;

        return articles.length > 0 && <>
            <div className="header-list-promo-articles">
                <NavLink to={getLinkPath(`/news/${slug}`)} onClick={scrollToTop} className="header-list-promo-link">
                    <span className="icon">
                        <SpriteIcon name={`#${spriteIcon}`} className="svg-default"/>
                    </span>
                    <span className="name">{category}</span>
                </NavLink>
            </div>
            <ArticlesContainer
                category={category}
                loading={loading}
                articles={articles}
                slug={slug}
                type={type || 'news'}
                containerForMainPage={containerForMainPage}
            />
        </>;
    }
}
